<template>
  <div class="button-container" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <transition name="slide-y-transition">
      <div class="button-hover-errors" v-if="isHoverErrorsShowing">
        <ul>
          <li v-for="(error, i) in hoverErrors" :key="i+'-hover-error'">{{ error }}</li>
        </ul>
      </div>
    </transition>
    <button @click="$emit('click')" :class="getClass()" :disabled="this.disabled">
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: "Button",
  props: {
    primary: Boolean,
    secondary: Boolean,
    tertiary: Boolean,
    positive: Boolean,
    error: Boolean,
    gray: Boolean,
    disabled: Boolean,
    hoverErrors: Array
  },
  data() {
    return {
      isHoverErrorsShowing: false
    };
  },
  methods: {
    handleMouseEnter() {
      if (this.hoverErrors && this.hoverErrors.length > 0) {
        this.isHoverErrorsShowing = true;
      }
    },
    handleMouseLeave() {
      this.isHoverErrorsShowing = false;
    },
    getClass() {
      let result = "button";

      if (this.primary) {
        result += " primary-btn";
      } else if (this.secondary) {
        result += " secondary-btn";
      } else if (this.tertiary) {
        result += " tertiary-btn";
      } else if (this.error) {
        result += " error-btn";
      } else if (this.positive) {
        result += " positive-btn";
      } else if (this.gray) {
        result += " gray-btn";
      } else {
        result += " secondary-btn";
      }
      if (this.disabled) {
        result += " disabled";
      }
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.button-container {
  display: inline-block;
  position: relative;
}

.button-hover-errors {
  background-color: $secondary;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 64px;

  width: max-content;
  max-width: 500px;

  border-radius: $border-radius;
  padding: 15px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      color: white;
    }
  }
}

.button {
  padding: 11px 21px;
  border-radius: $border-radius;

  text-transform: uppercase;
  text-align: center;
  font-weight: 600;

  outline: none;

  &.primary-btn {
    background-color: $tertiary;
    color: $quinary;
    font-weight: 700;
  }

  &.secondary-btn {
    background-color: $secondary;
    color: white;
  }

  &.tertiary-btn {
    background-color: $secondary-lighten-3;
    color: $secondary;
    font-weight: 700;
  }

  &.error-btn {
    background-color: $error;
    color: white;
  }

  &.positive-btn {
    background-color: $positive;
    color: white;
  }

  &.gray-btn {
    background-color: $gray;
    color: $primary;
    font-weight: 700;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
}
</style>
